import { useRef, useState, useEffect } from 'react';

// Simple reusable hook that returns a ref and an `inView` boolean.
// Options: { threshold = 0.15, root = null, rootMargin = '0px', once = true }
export default function useInView(options = {}) {
    const { threshold = 0.15, root = null, rootMargin = '0px', once = true } = options;
    const ref = useRef(null);
    const [inView, setInView] = useState(false);

    useEffect(() => {
        if (!ref.current) return;
        const node = ref.current;
        const obs = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        setInView(true);
                        if (once && obs && node) obs.unobserve(node);
                    } else if (!once) {
                        setInView(false);
                    }
                });
            },
            { threshold, root, rootMargin }
        );

        obs.observe(node);
        return () => obs.disconnect();
    }, [threshold, root, rootMargin, once]);

    return [ref, inView];
}
